// instantSearch.js: https://community.algolia.com/instantsearch.js/v2/getting-started.html

(function (window, document, $) {

    const init = () => {
        const searchIndex = location.host === 'raygun.com' ? 'prod' : 'dev';
        
        const search = window.instantsearch({
            appId: 'ZYP4EB8MXU',
            apiKey: '8db7b48f3c67cc3ce08ecc2f46180bca',
            indexName: `${searchIndex}_DOCUMENTATION`,
            routing: true
        });

        // Search input
        search.addWidget(
            instantsearch.widgets.searchBox({
                container: '#searchbox',
                magnifier: false,
                reset: false,
            })
        );

        // Refinements
        // Note: disabled for now.
        // search.addWidget(
        //     window.instantsearch.widgets.clearRefinements({
        //         container: '#clear-refinements',
        //     })
        // );

        // search.addWidget(
        //     window.instantsearch.widgets.refinementList({
        //         container: '#categories',
        //         attribute: 'categories',
        //     })
        // );

        // Results
        search.addWidget(
            window.instantsearch.widgets.hits({
                container: '#hits',
                cssClasses: {
                    empty: 'search-results__result',
                    item: 'search-results__result',
                },
                transformItems: (items) => {
                    items.map((item, i) => {
                        const dirs = item.dir.split('\\');
                        dirs.pop();
                        const dirsMap = dirs.map((d, i) => ({
                            dir: d,
                            url: `/documentation/${dirs.slice(0, i + 1).join('/')}`
                        }));

                        item.relPermalink = item.permalink.replace(/https?:\/\/raygun.com/, '');
                        item.dirs = dirsMap;
                        items[i] = item;
                    });

                    return items;
                },
                templates: {
                    empty: `
                        <h2 class="result-heading result-heading--no-result">No results</h2>
                    `,
                    item: `
                        <h2 class="result-heading"><a href="{{relPermalink}}">{{title}}</a></h2>
                        <ul class="result-breadcrumbs">
                            {{#dirs}}
                                <li class="result-breadcrumbs__breadcrumb"><a href="{{url}}">{{dir}}</a></li>
                            {{/dirs}}
                        </ul>
                        <p class="result-passage">
                            {{description}}
                        </p>
                    `,
                },
            })
        );


        // !! WIP
        // custom `renderFn` to render the custom InfiniteHits widget
        // function renderFn(InfiniteHitsRenderingOptions, isFirstRendering) {
        //     if (isFirstRendering) {
        //         InfiniteHitsRenderingOptions.widgetParams.containerNode
        //             .html('<div id="hits"></div>');

        //         InfiniteHitsRenderingOptions.widgetParams.containerNode
        //             .find('#show-more')
        //             .on('click', function(event) {
        //             event.preventDefault();
        //             InfiniteHitsRenderingOptions.showMore();
        //             });
        //     }
        
        //     InfiniteHitsRenderingOptions.widgetParams.containerNode.find('#hits').html(
        //     InfiniteHitsRenderingOptions.hits.map(function(hit) {
        //         return `
        //             <h2 class="result-heading"><a href="{{permalink}}">{{title}}</a></h2>
        //             <ul class="result-breadcrumbs">
        //                 {{#dirs}}
        //                     <li class="result-breadcrumbs__breadcrumb"><a href="#TODO">{{.}}</a></li>
        //                 {{/dirs}}
        //             </ul>
        //             <p class="result-passage">
        //                 {{description}}
        //             </p>
        //         `;
        //     })
        //     );
        // };

        // // connect `renderFn` to InfiniteHits logic
        // var customInfiniteHits = window.instantsearch.connectors.connectInfiniteHits(renderFn);

        // // mount widget on the page
        // search.addWidget(
        //     customInfiniteHits({
        //         containerNode: $('#infinite-hits'),
        //     })
        // );

        search.start();
    };

    $(document).ready(init);
})(window, window.document, window.jQuery);